import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useFormikContext } from 'formik'

import Text from '../../../../Text'
import {
  CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS,
  QA_NAME_CALENDAR_RELIEVE_DAY_AFTER,
} from '../../CalendarRelieveDayModal.constants'

import { FollowUpRow } from './FollowUpRow'
import {
  getCalendarRelieveDayFollowUpIds,
  getIsCalendarRelieveDayStillFull,
} from './FollowUpsField.utils'

import * as styles from './FollowUpsField.module.css'

function FollowUpsField({ dayLoad, followUps }) {
  const { t } = useTranslation()

  const { isSubmitting, setFieldValue, values } = useFormikContext()

  const selectedIds = values[CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS]

  const isStillFull = getIsCalendarRelieveDayStillFull({
    dayLoad,
    selectedCount: selectedIds.length,
  })

  function handleToggleFollowUp({ followUp, isChecked }) {
    setFieldValue(
      CALENDAR_RELIEVE_DAY_FIELD_NAME_FOLLOW_UP_IDS,
      getCalendarRelieveDayFollowUpIds({ followUp, isChecked, selectedIds })
    )
  }

  return (
    <div className={styles.FollowUpsField}>
      {followUps.map(followUp => (
        <FollowUpRow
          followUp={followUp}
          isChecked={selectedIds.includes(followUp.id)}
          isDisabled={isSubmitting}
          key={followUp.id}
          onToggle={handleToggleFollowUp}
        />
      ))}
      <Text
        className={classNames({ [styles.loadFull]: isStillFull })}
        isSecondary={!isStillFull}
        qaName={QA_NAME_CALENDAR_RELIEVE_DAY_AFTER}
      >
        {t('Calendar.RelieveDayAfterKey', {
          limit: dayLoad.limit,
          used: dayLoad.used - selectedIds.length,
        })}
      </Text>
    </div>
  )
}

export default FollowUpsField
